export enum Features {
  Preferences,
  DecisionSupportSystem,
  GroupDataByHour,
  DVP,
  Simulator,
  AIModels,
  PvWineMetrics,
}
